/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_Save_Hours_ArticleInputs */

const en_onboarding_results_save_hours_article = /** @type {(inputs: Onboarding_Results_Save_Hours_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2.5 hours`)
};

const es_onboarding_results_save_hours_article = /** @type {(inputs: Onboarding_Results_Save_Hours_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2.5 horas`)
};

/**
* | output |
* | --- |
* | "2.5 hours" |
*
* @param {Onboarding_Results_Save_Hours_ArticleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_save_hours_article = /** @type {((inputs?: Onboarding_Results_Save_Hours_ArticleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_Save_Hours_ArticleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_save_hours_article(inputs)
	return en_onboarding_results_save_hours_article(inputs)
});